import { createContext, useContext } from "react";
import type { MeOrg } from "../api/types";

export const OrgContext = createContext<MeOrg | null>(null);

/** The org from the URL (/o/:orgSlug). Only valid inside the app shell. */
export function useOrg(): MeOrg {
  const org = useContext(OrgContext);
  if (!org) throw new Error("useOrg must be used inside the app shell");
  return org;
}

/** Build an in-app path for the current org. */
export function useOrgPath() {
  const org = useOrg();
  return (path = "") => `/o/${org.slug}${path ? (path.startsWith("/") ? path : `/${path}`) : ""}`;
}
